<template>
  <div class="helpContractList">
    <help-header v-if="helpCategories && helpCategories.length" />
    <v-divider class="helpContractList_divider" />
    <h4 v-if="questions && questions.length" class="helpContractList_title">
      問い合わせの多い質問
    </h4>
    <section class="helpContractList_content">
      <section
        v-for="(item, index) in questions"
        :key="index"
        class="helpContractList_item-wrapper"
      >
        <div
          v-ripple
          class="helpContractList_item"
          @click="handleToggleQuestion(item.id)"
        >
          <div class="helpContractList-collapse">
            <h3>
              <span class="helpContractList-q_index">Q{{ index + 1 }}</span>
              {{ item.question }}
            </h3>
            <v-icon
              class="helpContractList-collapse--icon"
              :class="{
                ['helpContractList-collapse--icon-open']: questionOpen[item.id],
              }"
              size="22"
            >
              mdi-chevron-right
            </v-icon>
          </div>
          <span v-if="item.desc" class="helpContractList_item-desc">{{
            item.desc
          }}</span>
          <section
            v-if="item.details && item.details.length"
            class="helpContractList_item-details"
          >
            <h5
              v-for="(detail, detailIndex) in item.details"
              :key="detailIndex"
            >
              {{ detail.title }}
            </h5>
          </section>
        </div>
        <section v-show="questionOpen[item.id]" class="helpContractList-answer">
          <p>
            {{ item.answer }}
          </p>
        </section>
      </section>
    </section>

    <h4 class="helpContractList-need">サポートが必要ですか？</h4>
    <section class="helpContractList-need_box">
      <h3 class="helpContractList-need_box-title">お問い合わせ内容</h3>
      <v-textarea
        v-model="input"
        no-resize
        counter
        outlined
        background-color="white"
        placeholder="お問い合わせ内容を入力してください"
        rows="8"
        row-height="40"
        hint=" "
        persistent-hint
      >
        <template #counter="{ props }">
          <h6 class="helpContractList-need_input-bottom_counter">
            <em
              :class="{
                ['error']: props.value > maxInput,
                ['not-exceed']: props.value > 0 && !(props.value > maxInput),
              }"
              >{{ props.value }}</em
            >
            / {{ maxInput }}
          </h6>
          <input
            type="hidden"
            :value="(isDisable = props.value > maxInput || props.value === 0)"
          />
        </template>
        <template #message>
          <h6 class="helpContractList-need_input-bottom_message">
            {{ maxInput }}文字以内
          </h6>
        </template>
      </v-textarea>
      <section v-if="currentTopic.showCamSelect" class="helpContractList-cam">
        <div
          v-ripple
          class="helpContractList-collapse"
          @click="
            navigateTo({
              name: 'help-cam-select',
              params: {
                id: $route.params.id,
                topic: $route.params.topic,
                qid: 0,
              },
              query: {
                cam: selectedCamId,
              },
            })
          "
        >
          <h3>ご質問対象のカメラ</h3>
          <v-icon class="helpContractList-collapse--icon" size="22">
            mdi-chevron-right
          </v-icon>
          <h6>ご質問対象のカメラをカメラ一覧から選択</h6>
          <h4 v-if="selectedCam">{{ selectedCam.name }}</h4>
        </div>
      </section>
      <section
        v-if="currentTopic.showCamSelect"
        class="helpContractList-cam_permission"
        :class="{
          ['helpContractList-cam_permission--disabled']: !isCamSelected,
        }"
      >
        <div e class="helpContractList-cam_permission-title">
          <h3>カメラ映像の閲覧を許可</h3>
          <v-switch
            v-model="allowCamSwitch"
            :disabled="!isCamSelected"
            :ripple="false"
            dense
          ></v-switch>
          <h6>オペレーターがカメラ映像を閲覧する事を許可する</h6>
        </div>
      </section>
      <h4 class="helpContractList-need_note">
        以下の情報がメールに記載されます
      </h4>
      <section class="helpContractList-need_details">
        <section class="helpContractList-need_details-item">
          <span class="helpContractList-need_details-title"
            >メールアドレス</span
          >
          <p class="helpContractList-need_details-text">{{ userEmail }}</p>
        </section>
        <section class="helpContractList-need_details-item">
          <span class="helpContractList-need_details-title"
            >お問い合わせの種類</span
          >
          <p class="helpContractList-need_details-text">
            {{ currentCategory.title }} -
            {{ currentTopic.title }}
          </p>
        </section>
      </section>
    </section>

    <v-btn
      class="helpContractList-save"
      :disabled="isDisable || (currentTopic.showCamSelect && !isCamSelected)"
      @click="handleConfirm"
      >次へ</v-btn
    >
    <!-- Message dialog -->
    <clip-dialog-message
      :open="!!dialogMessageText"
      :message="dialogMessageText"
      @onClose="closeDialogMessage"
    />
    <!-- ----------------- -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import HelpHeader from '../HelpHeader.vue';
import ClipDialogMessage from '@/components/dialogs/ClipDialogMessage.vue';

export default {
  name: 'HelpContractList',
  components: {
    HelpHeader,
    ClipDialogMessage,
  },
  data() {
    return {
      dialogMessageText: '',
      isDisable: false,
      maxInput: 1000,
      questionOpen: {},
    };
  },
  computed: {
    ...mapState({
      helpCategories: (state) => state.help.categories,
      allowCam: (state) => state.help.allowCam,
      userInfo: (state) => state.common.userInfo,
      cameraList: (state) => state.common.cameraList,
    }),
    isCamSelected() {
      return +this.selectedCamId > 0;
    },
    currentCategory() {
      return (
        this.helpCategories.find((item) => item.id === this.$route.params.id) ||
        {}
      );
    },
    selectedCamId() {
      return this.$route.query.cam;
    },
    selectedCam() {
      return this.cameraList.find((c) => +c.id === +this.selectedCamId);
    },
    currentTopic() {
      return (
        (this.currentCategory.sub_topic || []).find(
          (item) => item.id === this.$route.params.topic
        ) || {}
      );
    },
    questions() {
      return this.currentTopic.list || [];
    },
    input: {
      get() {
        if (!this.currentTopic) {
          return '';
        }
        return this.currentTopic.input || '';
      },
      set(newValue) {
        if (!this.currentTopic) {
          return;
        }
        return this.setTopicInput({
          input: newValue,
          categoryId: this.currentCategory.id,
          topicId: this.currentTopic.id,
        });
      },
    },
    allowCamSwitch: {
      get() {
        return this.allowCam;
      },
      set(newValue) {
        return this.setAllowCam(newValue);
      },
    },
    username: () => 'セコム 太郎',
    userEmail() {
      return this.userInfo && this.userInfo.attributes
        ? this.userInfo.attributes.email
        : '';
    },
  },
  watch: {
    dialogMessageText(val) {
      val || this.closeDialogMessage();
    },
    cameraList(val) {
      this.setSelectedCam(val.find((c) => +c.id === +this.selectedCamId));
    },
  },
  mounted() {
    if (this.$route.query.dl === 1) {
      this.displayDeleteMessage();
    }
    this.setSelectedCam(
      this.cameraList.find((c) => +c.id === +this.selectedCamId)
    );
  },
  methods: {
    ...mapActions('help', ['setTopicInput', 'setAllowCam', 'setSelectedCam']),
    handleToggleQuestion(qid) {
      if (this.questionOpen[qid]) {
        this.$set(this.questionOpen, qid, false);
      } else {
        this.$set(this.questionOpen, qid, true);
      }
    },
    async handleConfirm() {
      this.navigateTo({
        name: 'help-confirm',
        params: {
          id: this.$route.params.id,
          topic: this.$route.params.topic,
          qid: 0,
        },
      });
    },
    navigateTo(route) {
      this.routerPush(route);
    },
    displayDeleteMessage() {
      this.dialogMessageText = 'グループを削除しました。';
      this.$router.replace({ query: null });
    },
    closeDialogMessage() {
      this.dialogMessageText = null;
    },
  },
};
</script>

<style lang="scss">
.helpContractList {
  &-answer {
    padding-top: 21px;
    max-height: 510px;
    overflow-y: auto;
    & > p {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #666;
    }
  }
  &_divider {
    margin-top: 15px;
    &.theme--light.v-divider {
      border-color: #ccc;
    }
  }
  &-q_index {
    width: 30px;
    margin-right: 5px;
    display: inline-block;
  }
  &_title {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #666;
    border-bottom: 1px solid #eee;
    padding: 10px 0;
  }
  &-need {
    margin-top: 32px;
    margin-bottom: 10px;
    font-size: 14px;
    text-align: left;
    color: #666;
    &_input {
      &-bottom {
        &_message,
        &_counter {
          font-size: 12px;
          text-align: left;
          color: #989898;
        }
        &_counter {
          em {
            &.error {
              color: #eb545b;
              background-color: unset !important;
            }
            &.not-exceed {
              color: #0075c2;
              background-color: unset !important;
            }
          }
        }
      }
    }
    &_note {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #666;
      margin-top: 11px;
      border-bottom: 1px solid #eeeeee;
      border-top: 1px solid #eeeeee;
      padding: 10px 0;
    }
    &_box {
      margin-top: 11px;
      box-shadow: 0 1px 0 0 #eee;
      background-color: #f3f3f3;
      padding: 15px;

      .v-textarea {
        &.v-text-field {
          &--outlined:not(.v-input--is-focused):not(.v-input--has-state)
            > .v-input__control
            > .v-input__slot
            fieldset {
            border-radius: 5px;
            border: solid 2px #ccc;
            background-color: #fff;
          }
          &--enclosed {
            .v-text-field__details {
              padding: 0;
            }
            .v-text-field__slot textarea {
              font-size: 16px;
              font-weight: normal;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.38;
              letter-spacing: normal;
              text-align: left;
              color: #666;
              &::placeholder {
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.38;
                letter-spacing: normal;
                text-align: left;
                color: #ccc;
              }
            }
          }
        }
      }
      &-title {
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #4b4b4b;
        margin-bottom: 10px;
      }
    }
    &_details {
      margin-top: 26px;
      &-item {
        display: flex;
      }
      &-title {
        width: 150px;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #4b4b4b;
      }
      &-text {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.14;
        letter-spacing: normal;
        text-align: left;
        color: #666;
        word-wrap: break-word;
      }
    }
  }
  &_content {
    padding: 0;
    max-height: 510px;
    overflow-y: auto;
  }

  &_item {
    padding: 15px 0;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    &-wrapper {
      border-bottom: 1px solid #eee;
    }

    h3 {
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
    &-desc {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #989898;
    }
    &-details {
      margin-top: 10px;
      h5 {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: left;
        color: #666;
      }
    }
  }
  &-collapse {
    cursor: pointer;
    display: inline-block;
    h3 {
      display: inline-block;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
    h4 {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #666;
      margin-top: 10px;
    }
    h6 {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #989898;
      margin-top: 5px;
    }
    &--icon {
      margin-left: 5px;
      color: #c1c1c1 !important;
      transform: rotate(90deg);
      &-open {
        transform: rotate(270deg);
      }
    }
  }
  &-cam {
    border-top: solid 1px #ffffff;
    border-bottom: solid 1px #ffffff;
    padding: 15px 0;

    & > .helpContractList-collapse {
      width: 100%;
    }

    &_permission {
      border-bottom: solid 1px #ffffff;
      padding: 15px 0;
      &--disabled {
        pointer-events: none;
        .helpContractList-cam_permission-title {
          h3,
          h6 {
            color: #ccc;
          }
        }
        .v-input.v-input--switch.v-input--is-disabled {
          opacity: 0.3;
        }
      }
      &-title {
        h3 {
          font-size: 14px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: normal;
          text-align: left;
          color: #4b4b4b;
          display: inline;
          margin-right: 10px;
        }
        h6 {
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          letter-spacing: normal;
          text-align: left;
          color: #989898;
        }
        .v-input.v-input--switch {
          margin-top: 0;
          padding-top: 0;
          display: inline-block;

          .v-input__control {
            .v-messages {
              display: none;
            }

            .v-input__slot {
              margin-bottom: 0;

              .v-input--selection-controls__input {
                .v-input--switch__track {
                  border-radius: 15px;
                  width: 40px;
                  left: -2px;
                  position: absolute;
                  opacity: 1;
                  right: 2px;
                  top: calc(50% - 12px);
                  height: 20px;
                  color: #cccccc !important;
                }

                .v-input--switch__track.primary--text {
                  color: #0075c2 !important;
                }

                .v-input--switch__thumb {
                  color: #ffffff !important;
                  width: 16px;
                  height: 16px;
                  box-shadow: -3px 0 3px 0 rgba(0, 0, 0, 0.1);
                }
              }

              .theme--light.v-label {
                font-size: 12px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                letter-spacing: 0.6px;
                color: #666;
              }
            }
          }
        }

        .v-input--radio-group {
          margin-top: 0;
          padding-top: 0;

          .v-input__control {
            .v-input__slot {
              margin-bottom: 0;

              .v-input--radio-group__input {
                .v-radio.theme--light {
                  &:last-child {
                    margin-right: 0;
                  }
                }

                .v-label.theme--light {
                  font-size: 12px;
                  font-weight: 500;
                  font-stretch: normal;
                  font-style: normal;
                  letter-spacing: 0.6px;
                  color: var(--text-color-2);
                }
              }
            }

            .v-messages.theme--light {
              display: none;
            }

            .v-icon {
              font-size: 20px;

              &.mdi-radiobox-marked {
                color: var(--background-color-3) !important;
              }
            }
          }

          &.custom-radio-inputs {
            .v-input--radio-group__input {
              width: 250px;
              height: 72px;
              flex-direction: column;
            }
          }
        }
      }
    }
  }
  &-save {
    margin-top: 16px;
    &.v-btn:not(.v-btn--round).v-size--default {
      width: 120px;
      height: 36px;
      border-radius: 5px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      background-color: #0075c2;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: center;
      color: #fff;
    }
    &.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
      background-color: #f3f3f3 !important;
      box-shadow: none;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: center;
      color: #ccc !important;
    }
  }
}
</style>
